var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{staticClass:"base-multiline-text-input",attrs:{"rows":_vm.rows,"cols":_vm.cols,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }